/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import {
    // IBuyboxAddToCartViewProps,
    // IBuyboxAddToOrderTemplateViewProps,
    // IBuyboxAddToWishlistViewProps,
    // IBuyboxCallbacks,
    IBuyboxData,
    // IBuyboxFindInStoreViewProps,
    // IBuyboxKeyInPriceViewProps,
    // IBuyboxProductConfigureDropdownViewProps,
    // IBuyboxProductConfigureViewProps,
    // IBuyboxProductQuantityViewProps,
    // IBuyboxProps,
    // IBuyboxShopSimilarLookViewProps,
    // IBuyboxState,
    IBuyboxViewProps
} from '@msdyn365-commerce-modules/buybox';
// import { IncrementalQuantity, ITelemetryContent, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';
import { parseString } from 'xml2js';
import { ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
// import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import {
    BuyBoxSelector,
    BuyBoxSelectorChildren,
    IBuyBoxConfigurator,
    getURLSearchParams,
    resetSearchParams,
    updateSearchParams
} from './components/buyboxconfigurator';
// import { IBuyBoxConfigurator, getURLSearchParams, updateSearchParams, resetSearchParams } from './components/buyboxconfigurator';

import {
    IBuyboxProps as IBuyboxExtentionProps
    // IBuyboxResources as IBuyboxExtentionResources
} from '../definition-extensions/buybox.ext.props.autogenerated';
import { ICProductSpecificationData } from '../../../data/buybox';
// import { BuyBoxSelector, BuyBoxSelectorChildren } from './components/buyboxconfigurator';
// import BuyBoxPrice from './components/buybox-price.component';
import { getCartState } from '@msdyn365-commerce/global-state';
// import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
// import { ProductDimension } from '@msdyn365-commerce/retail-proxy';
// import {
//     getMediaLocationsAsync,
//     getVariantsByDimensionValuesAsync
// } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { useState } from 'react';
import { CartLine, CommerceProperty, MediaLocation, ProductDimension, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { LogLevel } from '@msdyn365-commerce/retail-proxy/dist/interfaces/ITelemetry';
import { getVariantsByDimensionValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { logDetails } from '../../../utils/debug-mode';
import BuyBoxModal from './components/buybox-modal.component';
// import BuyBoxModal from './components/buybox-modal.component';

type Result = {
    [key: string]: string[];
};

type BackOrder = {
    isBackOrder: boolean;
    buttonLabel: string;
    backOrderDescription?: string;
};

// Function to evaluate the condition
export function evaluateCondition(condition: string, data: any) {
    // Replace property names in the condition with their values
    const conditionWithValues = condition.replace(/\b(\w+)\b/g, (match, propName) => {
        return data[propName] !== undefined ? JSON.stringify(data[propName]) : match;
    });

    // Evaluate the condition using Function constructor
    return new Function('return ' + conditionWithValues)();
}

// Function to calculate the expression
export function calculateExpression(expression: string) {
    return eval(expression);
}

export function imageExists(url: string) {
    var http = new XMLHttpRequest();

    http.open('HEAD', url, false);
    http.send();

    return http.status != 404;
}

const BuyboxView: React.FC<IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData & ICProductSpecificationData>> = props => {
    const { data, rating, config } = props;

    logDetails(props.context.app.config.debugMode, props);
    logDetails(props.context.app.config.debugMode, data.mediaLocationsForSelectedVariant);

    const productSpecificationData = data.productSpecificationData;

    const intlFormatter = props.context.cultureFormatter;

    const [currentSelectedProduct, setCurrentSelectedProduct] = useState<SimpleProduct>();

    const [buyBoxSelectors, setBuyBoxSelectors] = useState<IBuyBoxConfigurator>();
    // const [customAddToBag, setCustomAddToBag] = React.useState<boolean>(false);
    const [openModal, setOpenModal] = React.useState<boolean>(false);
    const [customPrice, setCustomPrice] = React.useState<number>();
    const [selectedQuantity, setSelectedQuantity] = React.useState<number>(1);
    // const [isResetButtonDisabled, setIsResetButtonDisabled] = React.useState<boolean>(true);
    const [backOrder, setBackOrder] = React.useState<BackOrder>({ isBackOrder: false, buttonLabel: '', backOrderDescription: '' });
    const [sampleItemUrl, setSampleItemUrl] = React.useState<string>('');
    const [cartError, setCartError] = React.useState<string>('');
    const [getValue, setGetValue] = React.useState<{ [key: string]: string }>({});

    // const [mediaLocations, setMediaLocations] = React.useState<MediaLocation[] | undefined>([]);
    const [constraints, setConstraints] = React.useState<Result>();
    const [applicable, setApplicable] = React.useState<string[]>([]);
    const [mediaLocations, setMediaLocations] = React.useState<MediaLocation[] | undefined>([]);

    const closeModal = () => {
        setOpenModal(false);
    };
    //
    // applicable;
    // constraints;
    // selectedQuantity;
    // productImages;

    React.useEffect(() => {
        setDefaultMediaLocations();
    }, []);

    const setDefaultMediaLocations = () => {
        const validImageLocations: MediaLocation[] = [];
        if (props.data.mediaLocationsForSelectedVariant.result && props.data.mediaLocationsForSelectedVariant.result.length > 0) {
            props.data.mediaLocationsForSelectedVariant.result.map(media => {
                if (media.Uri) {
                    if (imageExists(media.Uri)) {
                        validImageLocations.push(media);
                    }
                }
            });
        }
        setMediaLocations(validImageLocations);
    };
    logDetails(props.context.app.config.debugMode, mediaLocations);

    const [currentSelectedProductVariant, setCurrentSelectedProductVariant] = React.useState<SimpleProduct>();

    // const ref = React.useRef<HTMLFormElement>(null);

    // const user = props.context.request.user.isAuthenticated ? props.context.request.user : undefined;
    // const customerId = user?.customerAccountNumber;

    React.useEffect(() => {
        const product = data.product.result;

        if (
            !ObjectExtensions.isNullOrUndefined(product) &&
            !ObjectExtensions.isNullOrUndefined(product.ExtensionProperties) &&
            !ObjectExtensions.isNullOrUndefined(product.ExtensionProperties.find(prop => prop.Key === 'INSCONFIGURATION'))
        ) {
            setCurrentSelectedProduct(product);

            let insConfiguration = product.ExtensionProperties.find(prop => prop.Key === 'INSCONFIGURATION')?.Value?.StringValue;
            logDetails(props.context.app.config.debugMode, insConfiguration);
            if (!ObjectExtensions.isNullOrUndefined(insConfiguration)) {
                parseString(insConfiguration, (err: Error | null, result: IBuyBoxConfigurator) => {
                    if (err) {
                        props.context.telemetry.log(LogLevel.Error, err.message);
                        return;
                    }
                    setBuyBoxSelectors(result);
                    logDetails(props.context.app.config.debugMode, result);
                    setTimeout(() => {
                        if (Msdyn365.msdyn365Commerce.isBrowser) {
                            const url = window.location.href;
                            if (url.includes('#reviews')) {
                                const review = document.getElementById('reviews');
                                if (review) {
                                    review.scrollIntoView({ behavior: 'smooth' });
                                }
                            }
                        }
                    }, 100);
                });
            }
        }

        if (
            !ObjectExtensions.isNullOrUndefined(product) &&
            !ObjectExtensions.isNullOrUndefined(product.ExtensionProperties) &&
            !ObjectExtensions.isNullOrUndefined(product.ExtensionProperties.find(prop => prop.Key === 'INSISBACKORDER'))
        ) {
            const isBackOrder = product.ExtensionProperties.find(prop => prop.Key === 'INSISBACKORDER')?.Value?.BooleanValue;
            const buttonLabel = product.ExtensionProperties.find(prop => prop.Key === 'INSBACKORDERBUTTONLABEL')?.Value?.StringValue;
            const backOrderDescription = product.ExtensionProperties.find(prop => prop.Key === 'INSBACKORDERBUTTONWARNING')?.Value
                ?.StringValue;

            if (
                !ObjectExtensions.isNullOrUndefined(isBackOrder) &&
                !ObjectExtensions.isNullOrUndefined(buttonLabel) &&
                !ObjectExtensions.isNullOrUndefined(backOrderDescription)
            ) {
                setBackOrder({ isBackOrder, buttonLabel, backOrderDescription });
            }
            setSampleItemUrl(product.ExtensionProperties.find(prop => prop.Key === 'INSSAMPLEITEMID')?.Value?.StringValue || '');
        }
    }, []);

    React.useEffect(() => {
        setConstraints(setValue());
        setDefaultConfiguration();
        formValidation();
    }, [buyBoxSelectors]);

    const getPrice = (price: number | undefined) => {
        if (typeof price !== 'undefined') {
            return intlFormatter.formatCurrency(price);
        } else {
            return '';
        }
    };

    const setValue = () => {
        const result: Result = {};

        // buyBoxSelectors?.Model.Component[0].PriceCalculation.find(value => value.$.condition === 'true')?.$.expression
        let priceFromXml = 0;

        if (buyBoxSelectors && buyBoxSelectors?.Model.Component[0].PriceCalculation) {
            buyBoxSelectors.Model.Component[0].PriceCalculation.map(value => {
                if (value.$.condition.toLowerCase() === 'true') {
                    priceFromXml = parseFloat(value.$.expression);
                }
            });
        }

        let totalPrice = props.data.product.result?.Price || 0;

        if (totalPrice === 0) {
            totalPrice = priceFromXml;
        }

        const getSelectedValue: string[] = [];
        let imageName = '';
        let condition = '';
        let getValue: {
            [key: string]: string;
        } = {};

        getURLSearchParams().forEach((searchValue, currentkey) => {
            if (searchValue !== '' && buyBoxSelectors?.Model.Component[0].Attribute.find(key => key.$.name === currentkey)) {
                // setIsResetButtonDisabled(false);
                getSelectedValue.push(searchValue);

                condition += `${currentkey}=="${searchValue}" & `;
                getValue[currentkey] = searchValue;
                // imageName = imageName.slice(0, -1);
            }
            if (currentkey.toLowerCase() === 'coreboard') {
                imageName += `${searchValue}`;
            }
            if (currentkey === 'CoreColour' && searchValue === '') {
                setDefaultMediaLocations();
            }
            if (currentSelectedProduct?.ItemId && imageName) {
                logDetails(props.context.app.config.debugMode, `${currentSelectedProduct?.ItemId}-${imageName}.png`);

                const imageUrl = getImageUrl(`Products/${currentSelectedProduct?.ItemId}-${imageName}.png`);

                fetch(imageUrl)
                    .then(res => {
                        if (res.status === 200) {
                            setMediaLocations(prevState => {
                                if (prevState && prevState.length > 0) {
                                    const anyConfigImage = prevState.find(image => image.MediaPurpose === 'CONFIGIMAGE');
                                    if (anyConfigImage) {
                                        const withoutConfigImage = prevState.filter(image => image.MediaPurpose !== 'CONFIGIMAGE');
                                        return [{ Uri: imageUrl, MediaPurpose: 'CONFIGIMAGE' }, ...withoutConfigImage];
                                    } else {
                                        return [{ Uri: imageUrl, MediaPurpose: 'CONFIGIMAGE' }, ...prevState];
                                    }
                                }
                                return prevState;
                            });
                        } else {
                            setDefaultMediaLocations();
                        }
                    })
                    .catch(err => {
                        props.context.telemetry.log(LogLevel.Error, err.message);
                    });
            }

            // Don't touch this code ☠️☠️☠️
            buyBoxSelectors &&
                buyBoxSelectors.Model.Component[0].TableConstraint.map(value => {
                    const applicableVal: string[] = [];
                    value.Column.map(colValue => {
                        if (colValue.Attribute[0].$.name === currentkey) {
                            value.Column.map((_, index) => {
                                value.Row.map(rowValue => {
                                    if (rowValue.Cell[index] === searchValue) {
                                        const colNameKey = value.Column[index === 0 ? 1 : 0].Attribute[0].$.name;
                                        const colName = [colNameKey];
                                        applicableVal.push(...colName);
                                        const key = colNameKey;
                                        const aValue = rowValue.Cell[index === 0 ? 1 : 0];
                                        if (result[key]) {
                                            if (result[key].includes(aValue)) {
                                                result[key] = [];
                                            }
                                            result[key].push(aValue);
                                        } else {
                                            result[key] = [aValue];
                                        }
                                    }
                                });
                            });
                        }
                    });
                    setApplicable(prevApp => {
                        return [...prevApp, ...applicableVal];
                    });
                });
        });

        setGetValue(getValue);

        // totalPrice += parseFloat(value.$.expression);
        condition = condition.slice(0, -3);
        buyBoxSelectors &&
            buyBoxSelectors.Model.Component[0].PriceCalculation.map(value => {
                if (value.$.condition.toLowerCase() === 'true') {
                } else {
                    try {
                        const result: {
                            [key: string]: string;
                        } = {};

                        getURLSearchParams().forEach((searchValue, currentkey) => {
                            result[currentkey] = searchValue;
                        });

                        const data = value.$;

                        // Check if the condition is true for the given data

                        if (evaluateCondition(data.condition, result)) {
                            // If true, calculate the expression
                            const result = calculateExpression(data.expression);
                            totalPrice += result;
                        } else {
                        }
                    } catch (e) {
                        logDetails(props.context.app.config.debugMode, e);
                    }
                }
            });

        if (getSelectedValue.length === buyBoxSelectors?.Model.Component[0].Attribute.length) {
            if (buyBoxSelectors) {
            }
        }

        setCustomPrice(totalPrice);

        return result;
    };
    const getImageUrl = (imageUrl: string | undefined) => {
        return generateImageUrl(imageUrl, props.context.request.apiSettings) as string;
    };

    // getImageUrl('');

    const onValueChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;
        if (!selectedValue) {
            setApplicable([]);
        }
        const dataValue = e.currentTarget.dataset.value;

        updateSearchParams(dataValue, selectedValue);

        setConstraints(setValue());
    };

    const contstraints = new Set<string>();
    buyBoxSelectors &&
        buyBoxSelectors.Model.Component[0].TableConstraint.map(table => {
            table.Column.map(col => {
                contstraints.add(col.Attribute[0].$.name);
            });
        });

    // Set default value
    const setDefaultConfiguration = async () => {
        if (currentSelectedProduct) {
            const product: ProductDimension[] = [];
            const context = props.context.actionContext;
            const varients = await getVariantsByDimensionValuesAsync(
                { callerContext: context, queryResultSettings: {} },
                currentSelectedProduct.RecordId,
                props.context.request.apiSettings.channelId,
                product
            );
            varients.map(varient => {
                if (varient.Dimensions) {
                    varient.Dimensions.map(dim => {
                        if (dim.DimensionValue?.Value?.toLocaleLowerCase() === 'default') {
                            setCurrentSelectedProductVariant(varient);
                        }
                    });
                }
            });
        }
    };

    let possibleValues: { [key: string]: string };

    if (buyBoxSelectors) {
        const result: {
            [key: string]: string;
        } = {};

        getURLSearchParams().forEach((searchValue, currentkey) => {
            result[currentkey] = searchValue;
        });
        buyBoxSelectors.Model.Component[0].Attribute.map(attr => {
            if (getURLSearchParams().get(attr.$.name) === null && attr.$.default !== undefined) {
                result[attr.$.name] = attr.$.default;
            }
        });

        possibleValues = result;
    }

    const [isAddToCartBtnDisabled, setIsAddToCartBtnDisabled] = React.useState<boolean>(true);
    // const [formError, setFormError] = React.useState<string>('');

    const formValidation = () => {
        setTimeout(() => {
            if (Msdyn365.msdyn365Commerce.isBrowser) {
                var form = document.getElementById('configuratorForm') as HTMLFormElement;
                var requiredInputs = 0;

                // Loop through all form elements
                for (var i = 0; i < form.elements.length; i++) {
                    var element = form.elements[i];

                    // Check if the element is an input and has the 'required' attribute
                    if (element.tagName === 'SELECT' && element.hasAttribute('required')) {
                        requiredInputs++;
                    }
                }
                if (buyBoxSelectors) {
                    let selectedValueList = new Set<string>();
                    getURLSearchParams().forEach((searchValue, currentkey) => {
                        if (buyBoxSelectors.Model.Component[0].Attribute.find(key => key.$.name === currentkey)) {
                            if (searchValue !== '') {
                                selectedValueList.add(currentkey);
                            }
                        }
                    });
                    logDetails(props.context.app.config.debugMode, selectedValueList);

                    if (selectedValueList.size === requiredInputs) {
                        setIsAddToCartBtnDisabled(false);
                    } else {
                        setIsAddToCartBtnDisabled(true);
                    }
                } else {
                    setIsAddToCartBtnDisabled(false);
                }
            }
        }, 300);
    };

    const addToCartHandler = async () => {
        const cartState = await getCartState(props.context.actionContext);

        if (buyBoxSelectors) {
            let configarationValueXml = '';
            let configarationXml = '';

            getURLSearchParams().forEach((searchValue, currentkey) => {
                buyBoxSelectors?.Model.Component[0].Attribute.map(attr => {
                    buyBoxSelectors?.Model.EnumDomain.map(enumDomain => {
                        if (enumDomain.$.enumDomainId === attr.EnumDomain[0].$.enumDefinitionId) {
                            enumDomain.EnumValue.map(enumValue => {
                                if (enumValue.$.value === searchValue && currentkey === attr.$.name) {
                                    configarationValueXml += `<Attribute name="${currentkey}" readableName="${attr.$.displayName}" readableValue="${enumValue.$.displayValue}" value="${searchValue}"/>`;
                                }
                            });
                        }
                    });
                });
            });
            const hiddenAttrValue = buyBoxSelectors?.Model.Component[0]?.HiddenAttributeValue;
            if (hiddenAttrValue && hiddenAttrValue.length > 0) {
                hiddenAttrValue.map(hAttr => {
                    if (hAttr.Attribute && hAttr.Attribute.length > 0) {
                        hAttr.Attribute.map(attr => {
                            configarationValueXml += `<Attribute name="${attr.$.name}" readableName="${attr.$.displayName}" readableValue="${attr.$.value}" value="${attr.$.value}"/>`;
                        });
                    }
                });
            }

            const finalconfigarationValueXml = `<Session>${configarationValueXml}</Session>`;

            getURLSearchParams().forEach((searchValue, currentkey) => {
                const getUniqueId = buyBoxSelectors?.Model.Component[0].Attribute.find(key => {
                    return key.$.name === currentkey;
                });
                if (searchValue !== '' && buyBoxSelectors?.Model.Component[0].Attribute.find(key => key.$.name === currentkey)) {
                    // configarationXml += `<Attribute name="${currentkey}" uniqueId="${getUniqueId?.$.uniqueId}" isUserSelected="1" type="enum" value="${searchValue}"/>`;
                    configarationXml += `<Attribute uniqueId="${getUniqueId?.$.uniqueId}" name="${currentkey}" value="${searchValue}" type="enum" isUserSelected="1"/>`;
                }
            });
            buyBoxSelectors.Model.Component[0].Attribute.map(attr => {
                if (getURLSearchParams().get(attr.$.name) === null && attr.$.default !== undefined) {
                    configarationXml += `<Attribute uniqueId="${attr?.$.uniqueId}" name="${attr.$.name}" value="${attr.$.default}" type="enum" isUserSelected="1"/>`;
                }
            });
            // Adding HiddenConfiguration Values
            const hiddenAttr = buyBoxSelectors?.Model.Component[0]?.HiddenAttributeValue;
            if (hiddenAttr && hiddenAttr.length > 0) {
                hiddenAttr.map(hAttr => {
                    if (hAttr.Attribute && hAttr.Attribute.length > 0) {
                        hAttr.Attribute.map(attr => {
                            configarationXml += `<Attribute uniqueId="${attr?.$.uniqueId}" name="${attr.$.name}" value="${attr.$.value}" type="enum" isUserSelected="1"/>`;
                        });
                    }
                });
            }

            // Operation Line
            let operationXml = '';
            if (buyBoxSelectors?.Model.Component[0].OperationLine && buyBoxSelectors?.Model.Component[0].OperationLine.length > 0) {
                buyBoxSelectors?.Model.Component[0].OperationLine?.map(operation => {
                    if (operation.Condition && operation.Condition.length > 0) {
                        operation.Condition.map(condition => {
                            try {
                                const result: {
                                    [key: string]: string;
                                } = {};

                                getURLSearchParams().forEach((searchValue, currentkey) => {
                                    result[currentkey] = searchValue;
                                });
                                if (hiddenAttr && hiddenAttr.length > 0) {
                                    hiddenAttr.map(hAttr => {
                                        if (hAttr.Attribute && hAttr.Attribute.length > 0) {
                                            hAttr.Attribute.map(attr => {
                                                result[attr.$.name] = attr.$.value;
                                            });
                                        }
                                    });
                                }
                                buyBoxSelectors.Model.Component[0].Attribute.map(attr => {
                                    if (getURLSearchParams().get(attr.$.name) === null && attr.$.default !== undefined) {
                                        result[attr.$.name] = attr.$.default;
                                    }
                                });

                                const data = condition.$;

                                // Check if the condition is true for the given data

                                if (evaluateCondition(data.constraintText, result)) {
                                    operationXml += `<OperationLine name="${operation.$.name}" uniqueId="${operation.$.uniqueId}"><ConditionAttribute name="${condition.$.uniqueId}" value="true"/></OperationLine>`;
                                } else {
                                    operationXml += `<OperationLine name="${operation.$.name}" uniqueId="${operation.$.uniqueId}"><ConditionAttribute name="${condition.$.uniqueId}" value="false"/></OperationLine>`;
                                }
                            } catch (e) {}
                        });
                    }
                });
            }

            // Subpart
            let subPartXml = '';
            if (buyBoxSelectors?.Model.Component[0].SubPart && buyBoxSelectors?.Model.Component[0].SubPart.length > 0) {
                buyBoxSelectors?.Model.Component[0].SubPart?.map(operation => {
                    operation.Condition.map(condition => {
                        try {
                            const result: {
                                [key: string]: string;
                            } = {};

                            getURLSearchParams().forEach((searchValue, currentkey) => {
                                result[currentkey] = searchValue;
                            });
                            if (hiddenAttr && hiddenAttr.length > 0) {
                                hiddenAttr.map(hAttr => {
                                    if (hAttr.Attribute && hAttr.Attribute.length > 0) {
                                        hAttr.Attribute.map(attr => {
                                            result[attr.$.name] = attr.$.value;
                                        });
                                    }
                                });
                            }

                            buyBoxSelectors.Model.Component[0].Attribute.map(attr => {
                                if (getURLSearchParams().get(attr.$.name) === null && attr.$.default !== undefined) {
                                    result[attr.$.name] = attr.$.default;
                                }
                            });

                            const data = condition.$;

                            // Check if the condition is true for the given data

                            if (evaluateCondition(data.constraintText, result)) {
                                subPartXml += `<SubPart name="${operation.$.name}" uniqueId="${operation.$.uniqueId}"><ConditionAttribute name="${condition.$.uniqueId}" value="true"/></SubPart>`;
                            } else {
                                subPartXml += `<SubPart name="${operation.$.name}" uniqueId="${operation.$.uniqueId}"><ConditionAttribute name="${condition.$.uniqueId}" value="false"/></SubPart>`;
                            }
                        } catch (e) {
                            logDetails(props.context.app.config.debugMode, e);
                        }
                    });
                });
            }

            const finalConfigurationXml = `<Session><Component name="${buyBoxSelectors?.Model.$.name}" uniqueId="">${configarationXml}${operationXml}${subPartXml}</Component></Session>`;
            logDetails(props.context.app.config.debugMode, finalConfigurationXml);
            logDetails(props.context.app.config.debugMode, finalconfigarationValueXml);

            if (currentSelectedProduct) {
                const extensionProperties: CommerceProperty = {
                    Key: 'INSSELECTEDCONFIGURATION',
                    Value: {
                        StringValue: finalConfigurationXml
                    }
                };
                const insConfigValueXMl: CommerceProperty = {
                    Key: 'INSSELECTEDREADABLECONFIGURATION',
                    Value: {
                        StringValue: finalconfigarationValueXml
                    }
                };

                const configImage: CommerceProperty = {
                    Key: 'INSCONFIGURATIONIIMAGE',
                    Value: {
                        StringValue: primaryImage
                    }
                };
                currentSelectedProduct.RecordId = currentSelectedProductVariant?.RecordId
                    ? currentSelectedProductVariant.RecordId
                    : currentSelectedProduct.RecordId;

                const backOrderExtensionProps: CommerceProperty = {
                    Key: 'INSBACKORDERBUTTONWARNING',
                    Value: {
                        StringValue: backOrder.backOrderDescription
                    }
                };

                let cartResult = await cartState.addProductToCart({
                    product: currentSelectedProduct,
                    count: selectedQuantity,
                    customPrice,
                    isPriceKeyedIn: true
                });

                if (cartResult.status === 'SUCCESS') {
                    setOpenModal(true);
                } else {
                    setCartError((cartResult.validationResults && cartResult.validationResults[0].ErrorContext) || '');
                }

                let cartLine: CartLine[] = [];

                let cartLines = await cartState.cart.CartLines?.pop();

                cartLines?.ExtensionProperties?.push(extensionProperties);
                cartLines?.ExtensionProperties?.push(backOrderExtensionProps);
                if (configImage) {
                    cartLines?.ExtensionProperties?.push(configImage);
                }
                cartLines?.ExtensionProperties?.push(insConfigValueXMl);
                if (cartLines) {
                    cartLine.push(cartLines);
                    cartState.updateCartLines({
                        updatedCartLinesObject: cartLine
                    });
                }
            }
        } else {
            let cartResult = await cartState.addProductToCart({
                product: data.product.result as SimpleProduct,
                count: selectedQuantity
            });

            if (cartResult.status === 'SUCCESS') {
                setOpenModal(true);
            } else {
                setCartError((cartResult.validationResults && cartResult.validationResults[0].ErrorContext) || '');
            }
            await cartState.refreshCart({});
        }

        cartState.refreshCart({});
    };

    const resetConfiguration = () => {
        resetSearchParams();
        if (Msdyn365.msdyn365Commerce.isBrowser) {
            window.location.reload();
        }
    };

    const socialShare: Social[] = [
        {
            id: 1,
            name: 'Featured Image',
            label: 'Share',
            platform: 'whatsapp',
            className: 'social whatsapp',
            color: '#25d366',
            image: 'https://platform-cdn.sharethis.com/img/whatsapp.svg'
        },
        {
            id: 2,
            name: 'Featured Image',
            label: 'Share',
            platform: 'linkedin',
            className: 'social linkedin',
            color: '#0077b5',
            image: 'https://platform-cdn.sharethis.com/img/linkedin.svg'
        },
        {
            id: 3,
            name: 'Featured Image',
            label: 'Share',
            platform: 'messenger',
            className: 'social messenger',
            color: '#448AFF',
            image: 'https://platform-cdn.sharethis.com/img/messenger.svg'
        },
        {
            id: 3,
            name: 'Featured Image',
            label: 'Share',
            platform: 'facebook',
            className: 'social fb',
            color: '#4267B2',
            image: 'https://platform-cdn.sharethis.com/img/facebook.svg'
        }
    ];

    const openSocialLink = (platform: string) => () => {
        if (platform === 'whatsapp') {
            window.open(`https://api.whatsapp.com/send?text=${window.location.href}`, '_blank');
        }
        if (platform === 'linkedin') {
            // https://www.linkedin.com/shareArticle?url={url}&title={title}&summary={text}&source={provider}
            window.open(
                `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${document.title}&source=LinkedIn`,
                '_blank'
            );
        }
        if (platform === 'messenger') {
            window.open(`https://www.facebook.com/dialog/send?link=${window.location.href}`, '_blank');
        }
        if (platform === 'facebook') {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank');
        }
    };

    const updateQuantity = (type: 'increase' | 'decrease') => {
        if (type === 'increase') {
            setSelectedQuantity(prevState => {
                return prevState + 1;
            });
        } else {
            setSelectedQuantity(prevState => {
                if (prevState === 1) {
                    return prevState;
                } else {
                    return prevState - 1;
                }
            });
        }
    };

    React.useEffect(() => {
        if (mediaLocations && mediaLocations.length > 0) {
            setPrimaryImage(mediaLocations[0].Uri);
        }
    }, [mediaLocations]);

    const [primaryImage, setPrimaryImage] = React.useState<string | undefined>();

    return (
        <div className='ml_buybox__container'>
            <div className='ml_buybox__row ml_buybox__product-section'>
                <div className='ml_buybox__image-section ml_buybox__text-center ml_buybox__col-sm-12'>
                    {primaryImage && primaryImage.length > 0 && (
                        <div className='ml_buybox__featured-image'>
                            <img
                                src={primaryImage}
                                alt={primaryImage.split('/').pop() || ''}
                                onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.2)')}
                                onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
                                onError={e => {}}
                            />
                        </div>
                    )}
                    <div className='ml_buybox__row ml_buybox__gallery-thumb' style={{ justifyContent: 'center', overflowX: 'auto' }}>
                        {mediaLocations &&
                            mediaLocations.length > 0 &&
                            mediaLocations.map((image, index) => (
                                <div key={index} style={{ margin: '10px', cursor: 'pointer' }} onClick={() => setPrimaryImage(image.Uri)}>
                                    <img src={image.Uri} alt={image.AltText} />
                                </div>
                            ))}
                    </div>
                </div>
                <div className='ml_buybox__content-section ml_buybox__col-sm-12'>
                    <div className='ml_buybox__promo-img ml_buybox__text-center'>
                        <img src='https://shop.morlanduk.com/media/wysiwyg/morland-mix-and-match-promo.png' alt='promo' />
                    </div>
                    <div className='ml_buybox__product-details' style={{ border: '1px solid #c3c3c3' }}>
                        <div className='ml_buybox__product-heading'>
                            <div className='ml_buybox__col-sm-12'>
                                <h1 className='ml_buybox__product-title'>{data.product.result?.Name}</h1>
                            </div>
                        </div>
                        <div className='ml_buybox__row ml_buybox__social-share'>
                            {socialShare.map(icon => (
                                <div className={`ml_buybox__${icon.className}`} key={icon.id} onClick={openSocialLink(icon.platform)}>
                                    <img src={icon.image} alt={icon.name} style={{ width: '20px', height: '20px' }} />
                                    <span className='ml_buybox__social-label'>{icon.label}</span>
                                </div>
                            ))}
                        </div>
                        <div className='msc-rating__row'>
                            {rating}
                            <a href='#reviews'>Write a review</a>
                        </div>
                        {buyBoxSelectors ? (
                            <div className='ml_buybox__row ml_buybox__product-cutomisable'>
                                <p>
                                    NOW Customise your board.
                                    <a
                                        href={config.customiseLink?.destinationUrl}
                                        title='How to customise your panel'
                                        target='_blank'
                                        rel='noopener'
                                    >
                                        How?
                                    </a>
                                </p>
                            </div>
                        ) : null}
                        <div className='ml_buybox__row ml_buybox__product-form'>
                            <div className='ml_buybox__form'>
                                <form action='' id='configuratorForm' onChange={formValidation}>
                                    {buyBoxSelectors &&
                                        buyBoxSelectors.Model.Component.map(component => {
                                            return component.Attribute.map(attribute => {
                                                const children = buyBoxSelectors.Model.EnumDomain.find(
                                                    evalue => evalue.$.enumDomainId === attribute.EnumDomain[0].$.enumDefinitionId
                                                );
                                                return (
                                                    <>
                                                        <BuyBoxSelector
                                                            attribute={attribute}
                                                            onValueChange={onValueChange}
                                                            configValue={getValue}
                                                            hiddenAttributes={component.HiddenAttribute}
                                                            faqLink={props.app.routes.faq.destinationUrl}
                                                            possibleValues={possibleValues}
                                                            props={props}
                                                            infoList={config.infoList}
                                                        >
                                                            <BuyBoxSelectorChildren
                                                                applicable={applicable}
                                                                attribute={attribute}
                                                                children={children}
                                                                constraints={constraints}
                                                            />
                                                        </BuyBoxSelector>
                                                    </>
                                                );
                                            });
                                        })}
                                    {buyBoxSelectors && (
                                        <button className='ml_buybox__reset-button ml_buybox__col-sm-12' onClick={resetConfiguration}>
                                            RESET MY CUSTOMISATIONS
                                        </button>
                                    )}
                                </form>
                                <hr />
                                <div className='ml_buybox__row ml_buybox__product-price'>
                                    <p className='ml_buybox__sub-price'>
                                        <span>{getPrice(customPrice)}</span>
                                    </p>
                                </div>
                                {buyBoxSelectors && (
                                    <div>
                                        <span>Please select an option for the fields marked with *</span>
                                    </div>
                                )}
                                <div className='ml_buybox__row ml_buybox__product-add-to-cart'>
                                    <div className='cart-button-quantity'>
                                        <div className='items'>
                                            <button aria-label='Subtract' onClick={() => updateQuantity('decrease')}>
                                                -
                                            </button>
                                        </div>
                                        <div className='items-quantity'>
                                            <input
                                                id='item_qty'
                                                name='item_qty'
                                                type='number'
                                                value={selectedQuantity.toString()}
                                                placeholder=''
                                                min={1}
                                                max={10000}
                                                onChange={e => setSelectedQuantity(parseInt(e.target.value))}
                                            />
                                        </div>
                                        <div className='items'>
                                            <button aria-label='Add' onClick={() => updateQuantity('increase')}>
                                                +
                                            </button>
                                        </div>
                                    </div>

                                    <button
                                        className='ml_buybox__add-to-basket'
                                        onClick={addToCartHandler}
                                        disabled={isAddToCartBtnDisabled}
                                    >
                                        {backOrder.isBackOrder ? backOrder.buttonLabel : 'ADD TO BASKET'}
                                    </button>
                                    {sampleItemUrl.length > 0 ? (
                                        <a href={sampleItemUrl} target={'_blank'} className='ml_buybox__order-sample'>
                                            SAMPLE ITEM
                                        </a>
                                    ) : null}
                                </div>
                                <div>
                                    <span className='error'>{cartError}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ml_buybox__row ml_buybox__product-clr-block'></div>
            {!config.hideEsimatedShipping && (
                <div className='ml_buybox__SpEstimateDelivery'>
                    <div className='ml_buybox__SpEstimateDelivery-Row'>
                        <span className='ml_buybox__SpEstimateDelivery-Desc'>Estimated Delivery Date</span>
                        <span className='ml_buybox__SpEstimateDelivery-Date'>3 working days</span>
                        <br />
                        <span className='ml_buybox__SpEstimateDelivery-Desc'>Estimated Delivery Cost</span>
                        <span className='ml_buybox__SpEstimateDelivery-Cost'>0.00</span>
                    </div>
                </div>
            )}

            {/* <div className='ml_buybox__row ml_buybox__product-message'>
                {configurableItem?.Description && configurableItem?.Description.length > 0 ? (
                    <p className='ml_buybox__msg-text'>{configurableItem?.Description}</p>
                ) : null}
            </div> */}

            <div className='ml_buybox__product-desc'>
                <h3 className='ml_buybox__desc-title'>{data.product.result?.Description && 'Description'}</h3>
                <p className='ml_buybox__desc-sub-title'>{data.product.result?.Description}</p>
                <ul className='ml_buybox__desc-list'></ul>
            </div>
            <div className='ml_buybox__row ml_buybox__product-table-desc'>
                <div className='ml_buybox__product-info ml_buybox__col-sm-12'>
                    <table>
                        {/* <caption><h3 className='ml_buybox__desc-title'>{data.product.result?.Description && 'Description'}</h3></caption> */}
                        <thead>
                            <tr className='ml_buybox__table-heading'>
                                <th colSpan={2}>Product Information</th>
                            </tr>
                        </thead>
                        <tbody className='ml_buybox__table-data'>
                            <tr>
                                <td>Product Name</td>
                                <td>{data.product.result?.Name}</td>
                            </tr>
                            <tr>
                                <td>SKU</td>
                                <td>{data.product.result?.ItemId}</td>
                            </tr>
                            {productSpecificationData.result?.map(spec => {
                                return (
                                    <tr>
                                        <td>{spec.Name}</td>
                                        <td>{spec.TextValue}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <BuyBoxModal
                imageFullUrl={data.product.result?.PrimaryImageUrl}
                productPrice={getPrice(customPrice ? customPrice * selectedQuantity : customPrice)}
                productTitle={data.product.result?.Name}
                quantity={selectedQuantity}
                show={openModal}
                modalClose={closeModal}
                cartUrl={props.app.routes.cart.destinationUrl}
            />
        </div>
    );
};

interface Social {
    id: number;
    name: string;
    label: string;
    color: string;
    className: string;
    image: string;
    platform: string;
}

export default BuyboxView;
